import { IStandardDocumentVersionData } from 'types/order/documents/shared/interfaces';
import { ICreateDocumentAccess } from 'types/documents/ICreateDocumentAccess';
import { eDocumentType } from 'types/documents/eDocumentType';
import { Button, Grid, Header3Text, ModalWindow } from 'ui-toolkit/components';
import React from 'react';
import { Form, Formik } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/pro-light-svg-icons';
import { nbsp } from 'utilities/administration/magicStrings';

const initialValues = (standardDocument: IStandardDocumentVersionData | null): ICreateDocumentAccess => ({
  documentType: eDocumentType.Standard,
  documentId: standardDocument?.standardDocumentId || '',
  expiresAfterSeconds: 2592000, // 30 days
});

// const options: ISelectOption[] = [
//   { label: '2 days', value: 172800 },
//   { label: '15 days', value: 1296000 },
//   { label: '30 days', value: 2592000 },
//   { label: '60 days', value: 5184000 },
// ];

/*
  SelectField commented out at Patrick's request for the initial release of this shareable link.
  Subsequent iterations will have additions to this form, so it is retained.
  A future developer can un-comment the SelectField at their convenience. :-)
*/
export const ShareableLinkForm: React.FC<{
  onClose: () => void;
  standardDocument: IStandardDocumentVersionData | null;
  onSubmit: (createDocumentAccess: ICreateDocumentAccess) => void;
}> = ({ onClose, standardDocument, onSubmit }) => (
  <ModalWindow onClose={onClose} title={<FormTitle filename={standardDocument?.fileName} />}>
    <Formik onSubmit={onSubmit} initialValues={initialValues(standardDocument)} onReset={onClose}>
      <Form>
        <Grid>
          {/*<SelectField*/}
          {/*  name={'expiresAfterSeconds'}*/}
          {/*  label={'Expiration'}*/}
          {/*  hintText={'Determine how long this link will be active'}*/}
          {/*  options={options}*/}
          {/*  autoFocus*/}
          {/*  isRequired*/}
          {/*/>*/}
          <Grid columnCount={2}>
            <Button intent={'secondary'} type={'reset'}>
              Cancel
            </Button>
            <Button intent={'primary'} type={'submit'}>
              Share File
            </Button>
          </Grid>
        </Grid>
      </Form>
    </Formik>
  </ModalWindow>
);

const FormTitle: React.FC<{ filename?: string }> = ({ filename }) => (
  <Header3Text>
    <FontAwesomeIcon icon={faFilePdf} />
    {`${nbsp}${filename}`}
  </Header3Text>
);
